module.exports = __webpack_public_path__ + "img/fuwai.41a132ce.png";